import React, { useEffect, useState } from "react";
import {
  Container,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { Link, useNavigate } from "react-router-dom";
import { useMemo } from "react";
import {
  useTable,
  useSortBy,
  usePagination,
  useGlobalFilter,
} from "react-table";
import {
  Table,
  Row,
  Col,
  Card,
  CardBody,
  Modal,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Form,
  Label,
  Input,
} from "reactstrap";
import classnames from "classnames";
import Select from "react-select";

// assets
import "../../common/styles/hosting.css";
// import FixedProjectHeader from "../Projects/FixedProjectHeader"
import Draggable, { DraggableCore } from "react-draggable";
import { Resizable, ResizableBox } from "react-resizable";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import Dropzone from "react-dropzone";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import Pagi2 from "common/utils/Pagi2";
import userImg from "../../assets/images/users/AdminImg.png";
import SampleImg from "../../assets/images/DemoImg.png";
import FixedProjectHeader from "common/utils/FixedProjectHeader";
import secureLocalStorage from "react-secure-storage";
import axios from "axios";
import configure from "configure";

function TableContainer({
  columns,
  data,
  formPopup,
  setFormPopup,
  setAccessDenied,
  setFilter,
  filter,
  hostingType,
  setHostingType,
  selectToMove,
  setSelectToMove,
  setNoDrag,
  noDrag,
}) {
  const [fixedContent, setFixedContent] = useState(false);

  const navigate = useNavigate();

  document.addEventListener("scroll", () => {
    const scrollThreshold = window.innerHeight * 0.3;
    if (window.scrollY > scrollThreshold) {
      setFixedContent(true);
    } else {
      setFixedContent(false);
    }
  });
  // console.log("scrollY", window.scrollY)

  // Use the state and functions returned from useTable to build your UI
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    state,
    previousPage,
    nextPage,
    canPreviousPage,
    canNextPage,
    gotoPage,
    setPageSize,
    pageOptions,
    setGlobalFilter,
    pageCount,
    prepareRow,
  } = useTable(
    {
      columns,
      data,
      initialState: {
        sortBy: [
          {
            id: "id", // Set the ID of the first column for default sorting
            desc: true, // `true` for descending, `false` for ascending
          },
        ],
      },
    },

    useGlobalFilter,
    useSortBy,
    usePagination
  );

  const { pageIndex, pageSize, globalFilter } = state;

  useEffect(() => setPageSize(50), []);

  const [name_modal, setNameModal] = useState(false);
  const [title, setTitle] = useState("");

  const [viewData, setViewData] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [currency_data, setCurencyData] = useState([]);
  const [activeMoveStatus, setActiveMoveStatus] = useState(false);
  // const [isSelectIcon, setIsSelectIcon] = useState(true)

  // Handle Select All
  const handleSelectAll = () => {
    setSelectToMove(!selectToMove);
  };

  return (
    <div>
      <FixedProjectHeader
        columns={filter == "notAnswered" ? columns : "None"}
        data={data}
        setAccessDenied={setAccessDenied}
        support="true"
        setFilter={setFilter}
        filter={filter}
        setHostingType={setHostingType}
        hostingType={hostingType}
        setFormPopup={setFormPopup}
        formPopup={formPopup}
        setSelectToMove={setSelectToMove}
        selectToMove={selectToMove}
        setNoDrag={setNoDrag}
        noDrag={noDrag}
        cancelBtn={true}
        AllHosting={true}
        CurrentMonth={true}
      />

      <div className="position-relative">
        <Table className="table table-bordered" {...getTableProps()}>
          <thead
            className={`${
              fixedContent && page.length >= 5
                ? "fix-fixed-support-header"
                : "fix-table-header"
            } `}
          >
            {headerGroups.map((headerGroup, i) => (
              <tr key={i} {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column, index) => {
                  const classNames = column.className;
                  return (
                    <th
                      key={index}
                      className={`col-t-${index + 1} ${classNames} ${
                        index != 0 && "customShortIcon"
                      }`}
                      {...column.getHeaderProps(column.getSortByToggleProps())}
                    >
                      <div>
                        {/* <span style={{}}>{column.render("Header")}</span> */}
                        {column.render("Header")}
                        {column.isShortIcon ? (
                          <span
                            style={{
                              // position: index != 0 ? "absolute" : "",
                              // right: index != 0 ? "0" : "",
                              display: index == 0 ? "none" : "block",
                            }}
                            onClick={() =>
                              column.getSortByToggleProps().onClick()
                            }
                          >
                            <i
                              title="Ascending"
                              className={`bi bi-arrow-up ms-1 info-icon ${
                                column.isSorted && !column.isSortedDesc
                                  ? "text-dark"
                                  : ""
                              }`}
                            ></i>
                            <i
                              title="Descending"
                              className={`bi bi-arrow-down info-icon ${
                                column.isSorted && column.isSortedDesc
                                  ? "text-dark"
                                  : ""
                              }`}
                            ></i>
                          </span>
                        ) : null}

                        {column.isSelect ? (
                          <span
                            className="text-center"
                            // style={{
                            //   position: "absolute",
                            //   right: "1",
                            //   top : "10"
                            // }}
                            onClick={() => handleSelectAll()}
                          >
                            <input type="checkbox" />
                          </span>
                        ) : null}
                      </div>
                    </th>
                  );
                })}
              </tr>
            ))}
          </thead>

          <tbody className="fix-support-table-body" {...getTableBodyProps()}>
            {page.map((row, i) => {
              prepareRow(row);
              const { did_col: did, pwd_col: pwd } = row.original;
              const status = row.original.status_name;

              let backgroundStyle = {};

              // if (did <= 0 && pwd <= 0) {
              //   backgroundStyle = {
              //     background:
              //       "linear-gradient(90deg, rgba(190,49,8,1) 100%, rgba(242,222,9,1) 0%)",
              //   }
              // } else if (did <= 0 && pwd === 0) {
              //   backgroundStyle = {
              //     background:
              //       "linear-gradient(90deg, rgba(190,49,8,1) 75%, rgba(242,222,9,1) 25%)",
              //   }
              // } else if (did === 0 && pwd >= 0) {
              //   backgroundStyle = {
              //     background:
              //       "linear-gradient(90deg, rgba(190,49,8,1) 50%, rgba(242,222,9,1) 50%)",
              //   }
              // } else if (did >= 0 && pwd >= 0) {
              //   backgroundStyle = {
              //     background:
              //       "linear-gradient(90deg, rgba(190,49,8,1) 25%, rgba(242,222,9,1) 75%)",
              //   }
              // } else {
              //   backgroundStyle = {}
              // }
              const priority = row.original.priority_col;

              return (
                <tr {...row.getRowProps()} key={i} style={backgroundStyle}>
                  {row.cells.map((cell, index) => (
                    <td
                      key={index}
                      className={`t-col-${index + 1} ${cell.column.className} ${
                        priority == "High" ? "highPriority" : ""
                      }`}
                      {...cell.getCellProps()}
                    >
                      {cell.render("Cell")}
                    </td>
                  ))}
                </tr>
              );
            })}
          </tbody>
        </Table>
      </div>

      {/* Pagination */}
      <Row className="justify-content-md-end justify-content-center align-items-center">
        <Pagi2
          gotoPage={gotoPage}
          previousPage={previousPage}
          canPreviousPage={canPreviousPage}
          nextPage={nextPage}
          canNextPage={canNextPage}
          pageIndex={pageIndex}
          pageOptions={pageOptions}
        />
      </Row>
    </div>
  );
}

const HostingIndex = () => {
  const [verticalActiveTab, setverticalActiveTab] = useState("1");
  const [modal_fullscreen, setmodal_fullscreen] = useState(false);
  const [filter, setFilter] = useState("notAnswered");
  const [replyTiket, setReplyTiket] = useState(false);
  const [viewTicketHistory, setViewTicketHistory] = useState(false);
  const [ticketLogs, setTicketLogs] = useState(false);
  const [selectedFiles1, setselectedFiles1] = useState([]);
  const [formPopup, setFormPopup] = useState(false);
  const [editTask, setEditTask] = useState(false);
  const [boxWidth, setBoxWidth] = useState(0);
  const [noDrag, setNoDrag] = useState(false);

  const locationOptions = [
    { label: "India", value: "India" },
    { label: "UK", value: "UK" },
  ];

  const assignee = [
    { label: "Rahul Ovhal", value: "1" },
    { label: "Zain Marchawala", value: "2" },
    { label: "Manav", value: "3" },
  ];

  const priority = [
    { label: "Low", value: "Low" },
    { label: "Medium", value: "Medium" },
    { label: "High", value: "High" },
  ];
  const Type = [
    { label: "Bug", value: "Bug" },
    { label: "Suggestion", value: "Suggestion" },
  ];

  const related = [
    { label: "Project", value: "Project" },
    { label: "Contract", value: "Contract" },
  ];
  const project_type = [
    { label: "Earth", value: "Earth" },
    { label: "Mars", value: "Mars" },
  ];

  const toggleVertical = (tab) => {
    if (verticalActiveTab !== tab) {
      setverticalActiveTab(tab);
    }
  };

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") {
      if (modal_fullscreen) {
        setmodal_fullscreen(false);
      }
      if (replyTiket) {
        setReplyTiket(false);
      }
      if (viewTicketHistory) {
        setViewTicketHistory(false);
      }
      if (editTask) {
        setEditTask(false);
      }
    }
  });

  //meta title
  document.title = "Hosting | Zithas Technologies";

  // const [data, setDatas] = useState([])
  const [view_proposal, setViewProposal] = useState([]);
  const [isLoading, setLoading] = useState(false);

  //   useEffect(() => {
  //     setHostingType("7")
  //   }, [])

  // popup upate width
  useEffect(() => {
    const updateWidth = () => {
      const viewportWidth = window.innerWidth;
      setBoxWidth(viewportWidth * 0.72);
    };
    updateWidth();
    window.addEventListener("resize", updateWidth);
    return () => window.removeEventListener("resize", updateWidth);
  }, []);

  function handleAcceptedFiles1(files) {
    const updatedFiles = files.map((file) => ({
      ...file,
      preview: URL.createObjectURL(file),
      formattedSize: formatBytes(file.size),
    }));

    // Merge newly accepted files with existing selected files
    setselectedFiles1((prevFiles) => [...prevFiles, ...updatedFiles]);
  }

  function formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  }

  const [proposal_activity, setProposalActivity] = useState([]);
  const [proposal_revision, setProposalRevision] = useState([]);
  const [modal_Access, setAccessDenied] = useState(false);
  const navigate = useNavigate();
  const [hostingType, setHostingType] = useState("1");
  const [selectStatus, setSelectStatus] = useState(false);
  const [selectToMove, setSelectToMove] = useState(false);

  const handleChange = () => {
    setSelectToMove(!selectToMove);
  };
  const [Data, setData] = useState([]);

  useEffect(() => {
    fetchContract();
  }, []);

  const fetchContract = async () => {
    setLoading(true);
    const authUser = secureLocalStorage.getItem("Token");
    try {
      const response = await axios({
        method: "get",
        url: `${configure.apiUrl}/hosting`,
        // data: formData,
        headers: {
          Authorization: `Bearer ${authUser}`,
        },
      }).then((res) => {
        setData(res.data.hosting);
        setLoading(false);
      });
    } catch (error) {
      setLoading(false);
      console.log("fetchContract Error", error);
    }
  };

  const columns1 = useMemo(
    () => [
      {
        Header: "ID",
        accessor: "hosting_id",
        isInfoIcon: false,
        isShortIcon: false,
        className: "hosting_id",
      },
      {
        Header: "Project",
        accessor: "hosting_customer_name",
        isInfoIcon: false,
        isShortIcon: false,
        className: "hosting_customer_name_box",
      },
      {
        Header: "Package",
        accessor: "package_name",
        isInfoIcon: false,
        isShortIcon: false,
        className: "package_name_box",
      },
      {
        Header: "Package Price",
        accessor: "package_price",
        isInfoIcon: false,
        isShortIcon: false,
        className: "package_price_box",
      },
      {
        Header: "Start Date",
        accessor: "start_date",
        isInfoIcon: false,
        isShortIcon: false,
        className: "start_date_box",
      },

      {
        Header: "Renewal Duration",
        accessor: "renewal_duration",
        isInfoIcon: false,
        isShortIcon: false,
        className: "renewal_duration_col_box ",
      },
      {
        Header: "Due Date",
        accessor: "due_date",
        isInfoIcon: false,
        isShortIcon: false,
        className: "due_date_col-box",
      },

      {
        Header: "Action",
        accessor: "action",
        className: "hosting_action text-center",
        Cell: (cellProps) => {
          return (
            <div className="d-flex justify-content-center">
              <a
                // onClick={() => setEditTask(true)}
                className="btn btn-sm "
                title="Renew"
              >
                <span
                  className="badge bg-success text-white text-center cursor-pointer renew_btn"
                  style={{ fontSize: "13px" }}
                >
                  Renew
                </span>
              </a>
              <a
                // onClick={() => setEditTask(true)}
                className="btn btn-sm"
                title="Expired"
              >
                <span
                  className="badge bg-danger text-dark text-center cursor-pointer expired_btn"
                  style={{ fontSize: "13px" }}
                >
                  Expired
                </span>
              </a>
            </div>
          );
        },
      },
    ],
    []
  );

  const columns2 = useMemo(
    () => [
      {
        Header: "ID",
        accessor: "hosting_id",
        isInfoIcon: false,
        isShortIcon: false,
        className: "hosting_id",
      },
      {
        Header: "Project",
        accessor: "hosting_customer_name",
        isInfoIcon: false,
        isShortIcon: false,
        className: "hosting_customer_name_box",
      },
      {
        Header: "Package",
        accessor: "package_name",
        isInfoIcon: false,
        isShortIcon: false,
        className: "package_name_box",
      },
      {
        Header: "Package Price",
        accessor: "package_price",
        isInfoIcon: false,
        isShortIcon: false,
        className: "package_price_box",
      },
      {
        Header: "Start Date",
        accessor: "start_date",
        isInfoIcon: false,
        isShortIcon: false,
        className: "start_date_box",
      },

      {
        Header: "Renewal Duration",
        accessor: "renewal_duration",
        isInfoIcon: false,
        isShortIcon: false,
        className: "renewal_duration_col_box ",
      },
      {
        Header: "Due Date",
        accessor: "due_date",
        isInfoIcon: false,
        isShortIcon: false,
        className: "due_date_col-box",
      },

      {
        Header: "Action",
        accessor: "action",
        className: "hosting_action text-center",
        Cell: (cellProps) => {
          return (
            <div className="d-flex justify-content-center">
              <a
                // onClick={() => setReplyTiket(true)}
                className="btn btn-sm btn-outline-secondary me-1"
                title="Reply Ticket"
              >
                <i className="fas fa-reply"></i>
              </a>
              <a
                // onClick={() => setEditTask(true)}
                className="btn btn-sm btn-outline-secondary me-1"
                title="Edit Ticket"
              >
                <i className="fas fa-pen "></i>
              </a>
              <UncontrolledDropdown
                className="dropdown"
                style={{ width: "29px" }}
              >
                <DropdownToggle
                  className="btn btn-sm btn-outline-secondary w-100"
                  color="white"
                >
                  <i className="mdi mdi-dots-horizontal"></i>
                </DropdownToggle>
                <DropdownMenu className="dropdown-menu-end">
                  <Link
                    title="Ticket History"
                    className="dropdown-item"
                    // onClick={() => setViewTicketHistory(true)}
                  >
                    <i className="fas fa-solid fa-clock pr-10"></i> Ticket
                    History
                  </Link>

                  {/* <Link
                    title="Ticket Logs"
                    className="dropdown-item"
                    onClick={() => setTicketLogs(true)}
                  >
                    <i className="bi bi-arrow-left-circle pr-10"></i> Ticket
                    Logs
                  </Link> */}

                  <a
                    className="dropdown-item"
                    title="Delete Ticket"
                    // onClick={onDeleteLead}
                  >
                    <i className="fas fa-trash-alt text-danger pr-10"></i>{" "}
                    Delete Ticket
                  </a>
                </DropdownMenu>
              </UncontrolledDropdown>
            </div>
          );
        },
      },
    ],
    []
  );

  const defaultColumns = columns1;
  // const [column, setColumns] = useState(defaultColumns);

  const columns = useMemo(() => {
    switch (hostingType) {
      case "1":
        return columns1;
      case "2":
        return columns2;
      default:
        return defaultColumns; // or an empty array
    }
  }, [hostingType]);

  const data1 = [
    {
      hosting_id: "3166",
      hosting_customer_name: "Earth Development + ZAI",
      package_name: "Silver Package",
      package_price: "₹ 15,000",
      start_date: "10-08-2024",
      renewal_duration: "180 Days",
      due_date: "12-08-2025",
    },
    {
      hosting_id: "3167",
      hosting_customer_name: "Earth Development + ZAI",
      package_name: "Silver Package",
      package_price: "₹ 15,000",
      start_date: "10-08-2024",
      renewal_duration: "180 Days",
      due_date: "12-08-2025",
    },
    {
      hosting_id: "3168",
      hosting_customer_name: "Earth Development + ZAI",
      package_name: "Silver Package",
      package_price: "₹ 15,000",
      start_date: "10-08-2024",
      renewal_duration: "180 Days",
      due_date: "12-08-2025",
    },
    {
      hosting_id: "3169",
      hosting_customer_name: "Earth Development + ZAI",
      package_name: "Silver Package",
      package_price: "₹ 15,000",
      start_date: "10-08-2024",
      renewal_duration: "180 Days",
      due_date: "12-08-2025",
    },
    {
      hosting_id: "3170",
      hosting_customer_name: "Earth Development + ZAI",
      package_name: "Silver Package",
      package_price: "₹ 15,000",
      start_date: "10-08-2024",
      renewal_duration: "180 Days",
      due_date: "12-08-2025",
    },
    {
      hosting_id: "3171",
      hosting_customer_name: "Earth Development + ZAI",
      package_name: "Silver Package",
      package_price: "₹ 15,000",
      start_date: "10-08-2024",
      renewal_duration: "180 Days",
      due_date: "12-08-2025",
    },
  ];

  const data2 = [
    {
      hosting_id: "3166",
      hosting_customer_name: "Earth Development + Marketing Module",
      package_name: "Silver Package",
      package_price: "₹ 15,000",
      start_date: "10-08-2024",
      renewal_duration: "180 Days",
      due_date: "12-08-2025",
    },
    {
      hosting_id: "3167",
      hosting_customer_name: "Earth Development + Marketing Module",
      package_name: "Silver Package",
      package_price: "₹ 15,000",
      start_date: "10-08-2024",
      renewal_duration: "180 Days",
      due_date: "12-08-2025",
    },
    {
      hosting_id: "3168",
      hosting_customer_name: "Earth Development + Marketing Module",
      package_name: "Silver Package",
      package_price: "₹ 15,000",
      start_date: "10-08-2024",
      renewal_duration: "180 Days",
      due_date: "12-08-2025",
    },
    {
      hosting_id: "3169",
      hosting_customer_name: "Earth Development + Marketing Module",
      package_name: "Silver Package",
      package_price: "₹ 15,000",
      start_date: "10-08-2024",
      renewal_duration: "180 Days",
      due_date: "12-08-2025",
    },
    {
      hosting_id: "3170",
      hosting_customer_name: "Earth Development + Marketing Module",
      package_name: "Silver Package",
      package_price: "₹ 15,000",
      start_date: "10-08-2024",
      renewal_duration: "180 Days",
      due_date: "12-08-2025",
    },
    {
      hosting_id: "3171",
      hosting_customer_name: "Earth Development + Marketing Module",
      package_name: "Silver Package",
      package_price: "₹ 15,000",
      start_date: "10-08-2024",
      renewal_duration: "180 Days",
      due_date: "12-08-2025",
    },
  ];

  const defaultData = data1;

  const data = useMemo(() => {
    switch (hostingType) {
      case "1":
        return data1;
      case "2":
        return data2;
      default:
        return defaultData; // or an empty array
    }
  }, [hostingType]);

  // return (
  //   <React.Fragment>
  //     <div className="page-content">
  //       <Container fluid>
  //         <Breadcrumbs title={"Dashboard"} breadcrumbItem={"Hosting"} />
  //         <Row>
  //           <Col lg={12} className="p-0">
  //             <Card>
  //               <CardBody>
  //                 <div className="responsive-table">
  //                   <TableContainer
  //                     columns={columns}
  //                     data={data}
  //                     setAccessDenied={setAccessDenied}
  //                     setFilter={setFilter}
  //                     filter={filter}
  //                     hostingType={hostingType}
  //                     setHostingType={setHostingType}
  //                     formPopup={formPopup}
  //                     setFormPopup={setFormPopup}
  //                     selectToMove = {selectToMove}
  //                     setSelectToMove = {setSelectToMove}
  //                     setNoDrag = {setNoDrag}
  //                     noDrag = {noDrag}
  //                   />
  //                 </div>
  //               </CardBody>
  //             </Card>
  //           </Col>
  //         </Row>
  //       </Container>
  //     </div>

  //     {/* Edit Ticket  */}
  //     <div className={`note-sticky-form ${editTask ? "d-block" : "d-none"}`}>
  //       <Draggable handle={`${noDrag ? ".modal-header" : ""}`} cancel={`${noDrag ? ".modal-body" : ""}`}
  //       >
  //         <ResizableBox
  //           width={boxWidth}
  //           style={{
  //             position: "fixed",
  //             top: "16%",
  //             right: "16%",
  //             zIndex: "1055",
  //             backgroundColor: "#fff",
  //             maxHeight :"fit-content",
  //             transform: "translate(-50%, -50%)"
  //           }}
  //         >
  //           <div className="modal-header pe-4">
  //             <h5 className="modal-title mt-0">Edit Ticket</h5>
  //             <button
  //               type="button"
  //               onClick={() => {
  //                 setEditTask(false)
  //               }}
  //               className="btn-modal-close"
  //             >
  //               <span aria-hidden="true" className="btn-modal-span">
  //                 &times;;
  //               </span>
  //             </button>
  //           </div>

  //           <div className="modal-body pe-4">
  //             <Form className="row d-flex justify-content-center align-items-center">
  //               {/* <div className="my-2 text-end">
  //                 <button className=" btn btn-save btn-label">
  //                   <i className="fas fa-save me-2 label-icon"></i>
  //                   Submit
  //                 </button>
  //                 <a
  //                   onClick={() => setEditTask(false)}
  //                   className=" btn ms-md-2 btn-red btn-label"
  //                 >
  //                   <i className="dripicons-cross me-2 icon-center label-icon"></i>
  //                   CANCEL
  //                 </a>
  //               </div> */}
  //               <div className="col-md-12 d-flex flex-column new-task-modal mt-4 ticket-history-box">
  //                 <div className="col-md-12 d-flex mb-4 justify-content-start align-items-end">
  //                   <div className="col-sm-2 ps-2">
  //                     <Label htmlFor="formrow-firstname-Input">
  //                       Location <span className="text-danger">*</span>
  //                     </Label>
  //                     <Select
  //                       placeholder="- Select -"
  //                       className="basic-multi-select"
  //                       classNamePrefix=" select"
  //                       options={locationOptions}
  //                     />
  //                   </div>
  //                   <div className="col-sm-8 ps-2">
  //                     <Label htmlFor="formrow-firstname-Input">
  //                       Title <span className="text-danger">*</span>
  //                     </Label>
  //                     <div className="d-flex justify-content-start align-items-center gap-2">
  //                       <Input
  //                         type="text"
  //                         className="form-control"
  //                         placeholder="Enter Title"
  //                         onDoubleClick={() => setNoDrag(true)}
  //                         onMouseLeave={() => setNoDrag(false)}
  //                         onMouseEnter={() => setNoDrag(true)}
  //                       />
  //                     </div>
  //                   </div>
  //                   <div className="col-sm-2 ps-2">
  //                     <Label htmlFor="formrow-firstname-Input">Type</Label>
  //                     <Select
  //                       placeholder="- Select -"
  //                       className="basic-multi-select"
  //                       classNamePrefix=" select"
  //                       options={Type}
  //                     />
  //                   </div>
  //                 </div>
  //                 <div className="col-md-12 d-flex mb-4 justify-content-start align-items-end">
  //                   <div className="col-sm-2 ps-2">
  //                     <Label htmlFor="formrow-firstname-Input">Related</Label>
  //                     <Select
  //                       placeholder="- Select -"
  //                       className="basic-multi-select"
  //                       classNamePrefix=" select"
  //                       options={related}
  //                     />
  //                   </div>
  //                   <div className="col-sm-4 ps-2">
  //                     <Label htmlFor="formrow-firstname-Input">
  //                       Select Project
  //                     </Label>
  //                     <Select
  //                       placeholder="- Select -"
  //                       className="basic-multi-select"
  //                       classNamePrefix=" select"
  //                       options={project_type}
  //                     />
  //                   </div>
  //                   <div className="col-sm-4 ps-2">
  //                     <Label htmlFor="formrow-firstname-Input">
  //                       Assigned Ticket <span className="text-danger">*</span>
  //                     </Label>
  //                     <Select
  //                       placeholder="- Select -"
  //                       className="basic-multi-select"
  //                       classNamePrefix=" select"
  //                       options={assignee}
  //                     />
  //                   </div>
  //                   <div className="col-sm-2 ps-2">
  //                     <Label htmlFor="formrow-firstname-Input">
  //                       Priority <span className="text-danger">*</span>
  //                     </Label>
  //                     <Select
  //                       placeholder="- Select -"
  //                       className="basic-multi-select"
  //                       classNamePrefix=" select"
  //                       options={priority}
  //                     />
  //                   </div>
  //                 </div>
  //                 <div className="col-md-12 d-flex mb-4 justify-content-start align-items-end flex-column gap-4">
  //                   <div className="col-12 ps-2">
  //                     <label htmlFor="">Description</label>
  //                     <div
  //                       className="no-drag"
  //                       onDoubleClick={() => setNoDrag(true)}
  //                       onMouseLeave={() => setNoDrag(false)}
  //                       onMouseEnter={() => setNoDrag(true)}
  //                       >
  //                       <CKEditor
  //                         style={{ height: "500px" }}
  //                         editor={ClassicEditor}
  //                         onReady={editor => {}}
  //                         onChange={(event, editor) => {
  //                           const data = editor.getData()
  //                         }}
  //                       />
  //                     </div>
  //                   </div>
  //                   <div className="col-md-12 d-flex justify-space-between align-items-center">
  //                     <div className="col-md-8 ps-2 d-flex flex-column gap-2">
  //                       <Label htmlFor="formrow-firstname-Input mb-0">
  //                         Image
  //                       </Label>
  //                       <div className="d-flex text-start gap-2 flex-wrap pb-2">
  //                         <span
  //                           className="text-light badge bg-primary"
  //                           title="Click To Open"
  //                           style={{ cursor: "pointer", fontSize: "0.8rem" }}
  //                         >
  //                           Support Section Add Task
  //                           <i
  //                             className="fas fa-times text-danger ps-1"
  //                             title="Remove"
  //                           ></i>
  //                         </span>
  //                         <span
  //                           className="text-light badge bg-primary"
  //                           title="Click To Open"
  //                           style={{ cursor: "pointer", fontSize: "0.8rem" }}
  //                         >
  //                           Support Section Edit Task
  //                           <i
  //                             className="fas fa-times text-danger ps-1"
  //                             title="Remove"
  //                           ></i>
  //                         </span>
  //                         <span
  //                           className="text-light badge bg-primary"
  //                           title="Click To Open"
  //                           style={{ cursor: "pointer", fontSize: "0.8rem" }}
  //                         >
  //                           Support Section Reply Task{" "}
  //                           <i
  //                             className="fas fa-times text-danger ps-1"
  //                             title="Remove"
  //                           ></i>
  //                         </span>
  //                       </div>
  //                     </div>

  //                     <div className="my-2 text-end">
  //                       <button className=" btn btn-save btn-label">
  //                         <i className="fas fa-save me-2 label-icon"></i>
  //                         Submit
  //                       </button>
  //                       <a
  //                         onClick={() => setEditTask(false)}
  //                         className=" btn ms-md-2 btn-red btn-label"
  //                       >
  //                         <i className="dripicons-cross me-2 icon-center label-icon"></i>
  //                         CANCEL
  //                       </a>
  //                     </div>
  //                   </div>
  //                 </div>
  //                 {/* <Row className="bg-white px-2 py-2 shadow mb-3">
  //                     <div className="d-flex justify-content-end align-items-end px-0">
  //                       <div className="text-end mb-3">
  //                         <button
  //                           onClick={e => {
  //                             e.preventDefault()
  //                             onAddFormRow()
  //                           }}
  //                           className="btn btn-purple  "
  //                         >
  //                           <i className="fas fa-plus me-2"></i>
  //                           Add Subtask
  //                         </button>
  //                       </div>
  //                     </div>

  //                   </Row> */}
  //               </div>
  //             </Form>
  //           </div>
  //         </ResizableBox>
  //       </Draggable>
  //     </div>

  //     {/* Reply Ticket  */}
  //     <div className={`note-sticky-form ${replyTiket ? "d-block" : "d-none"}`}>
  //       <Draggable handle={`${noDrag ? ".modal-header" : ""}`} cancel={`${noDrag ? ".modal-body" : ""}`}>
  //         <ResizableBox
  //           width={boxWidth}
  //           style={{
  //             position: "fixed",
  //             top: "16%",
  //             right: "16%",
  //             zIndex: "1055",
  //             backgroundColor: "#fff",
  //             maxHeight :"fit-content",
  //             transform: "translate(-50%, -50%)"
  //           }}
  //         >
  //           <div className="modal-header pe-4 mb-3">
  //             <h5 className="modal-title mt-0">Reply Ticket </h5>
  //             {/* <button
  //               type="button"
  //               onClick={() => {
  //                 setReplyTiket(false)
  //               }}
  //               className="btn-modal-close"
  //             >
  //               <span aria-hidden="true" className="btn-modal-span">
  //                 &times;;
  //               </span>
  //             </button> */}

  //           </div>

  //           <div className="modal-body pe-4">
  //             <Form className="row d-flex justify-content-center align-items-center">
  //               {/* <div className="my-2 text-end">
  //                 <button className=" btn btn-save btn-label">
  //                   <i className="fas fa-save me-2 label-icon"></i>
  //                   Submit
  //                 </button>
  //                 <a
  //                   onClick={() => setReplyTiket(false)}
  //                   className=" btn ms-md-2 btn-red btn-label"
  //                 >
  //                   <i className="dripicons-cross me-2 icon-center label-icon"></i>
  //                   CANCEL
  //                 </a>
  //               </div> */}
  //               <div className="col-md-12 d-flex flex-column new-task-modal ">
  //                 <div className="col-md-12 d-flex mb-4 justify-content-start align-items-end flex-column gap-4">
  //                   <div className="col-12 ps-2">

  //                     <label htmlFor="">Description</label>
  //                     <div
  //                      className="no-drag"
  //                      onDoubleClick={() => setNoDrag(true)}
  //                      onMouseLeave={() => setNoDrag(false)}
  //                      onMouseEnter={() => setNoDrag(true)}
  //                     >
  //                       <CKEditor
  //                         editor={ClassicEditor}
  //                         onReady={editor => {}}
  //                         onChange={(event, editor) => {
  //                           const data = editor.getData()
  //                         }}
  //                       />
  //                     </div>
  //                   </div>
  //                   <div className="col-md-12 d-flex">
  //                     <div className="col-md-6 d-flex justify-content-start align-items-center gap-3">
  //                       <div className="col-md-4 col-sm-6 mt-3">
  //                         <label htmlFor="">Attachment</label>
  //                         {/* custom file upload */}
  //                         <Dropzone
  //                           onDrop={acceptedFiles => {
  //                             handleAcceptedFiles1(acceptedFiles)
  //                           }}
  //                         >
  //                           {({ getRootProps, getInputProps }) => (
  //                             <div
  //                               className="dz-message needsclick p-0"
  //                               {...getRootProps()}
  //                             >
  //                               <input {...getInputProps()} />
  //                               <div className="d-flex px-2 custom-file-upload align-items-center">
  //                                 <div className="">
  //                                   <i className="display-6 text-muted bx bxs-cloud-upload" />
  //                                 </div>
  //                                 <h5 className="mb-0 ms-2">Upload Files</h5>
  //                               </div>
  //                             </div>
  //                           )}
  //                         </Dropzone>
  //                       </div>
  //                       {/* file display here */}
  //                       <div
  //                         className={`mt-3 dropzone-previews ${
  //                           selectedFiles1.length > 0 ? "d-block" : "d-none"
  //                         }`}
  //                         id="file-previews"
  //                       >
  //                         <label className="mb-1">Uploaded Files</label>
  //                         <Card className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete">
  //                           <div className="p-0">
  //                             <Row className="align-items-center justify-content-evenly">
  //                               {selectedFiles1?.map((f, i) => {
  //                                 return (
  //                                   <Col key={i} className="col-auto">
  //                                     <img
  //                                       data-dz-thumbnail=""
  //                                       height="80"
  //                                       className="avatar-sm rounded bg-light"
  //                                       alt={f.name}
  //                                       src={f.preview}
  //                                     />
  //                                   </Col>
  //                                 )
  //                               })}
  //                             </Row>
  //                           </div>
  //                         </Card>
  //                       </div>
  //                     </div>
  //                     <div className="col-md-6 d-flex gap-3 justify-content-end align-items-end">
  //                     <div className="my-2 text-end">
  //                         <button className=" btn btn-save btn-label">
  //                           <i className="fas fa-save me-2 label-icon"></i>
  //                           Submit
  //                         </button>
  //                         <a
  //                           onClick={() => setReplyTiket(false)}
  //                           className=" btn ms-md-2 btn-red btn-label"
  //                         >
  //                           <i className="dripicons-cross me-2 icon-center label-icon"></i>
  //                           CANCEL
  //                         </a>
  //                       </div>
  //                     </div>
  //                   </div>
  //                 </div>
  //               </div>
  //             </Form>
  //           </div>
  //         </ResizableBox>
  //       </Draggable>
  //     </div>

  //     {/* Ticket History */}
  //     <div
  //       className={`note-sticky-form ${
  //         viewTicketHistory ? "d-block" : "d-none"
  //       }`}
  //     >
  //       <Draggable>
  //         <ResizableBox
  //           width={boxWidth}
  //           style={{
  //             position: "fixed",
  //             top: "12%",
  //             left: "15%",
  //             zIndex: "1055",
  //             backgroundColor: "#fff",
  //             maxHeight :"fit-content",
  //             transform: "translate(-50%, -50%)"
  //           }}
  //         >
  //           <div className="modal-header pe-4">
  //             <h5 className="modal-title mt-0">Ticket History</h5>
  //             <button
  //               type="button"
  //               onClick={() => {
  //                 setViewTicketHistory(false)
  //               }}
  //               className="btn-modal-close"
  //             >
  //               <span aria-hidden="true" className="btn-modal-span">
  //                 &times;;
  //               </span>
  //             </button>
  //           </div>
  //           <div className="px-3 py-4 bg-white">

  //             {/* Static Notes Section */}
  //             <div className="mt-4 ticket-history-box">
  //               <ul className="verti-timeline list-unstyled notes-box">
  //                 {/* Message 1 */}
  //                 <li className="event-list position-relative">
  //                   <div className="event-timeline-dot connected-dot">
  //                     <img
  //                       src={userImg}
  //                       className="msgUserImg me-3"
  //                       alt="User Avatar"
  //                     />
  //                   </div>
  //                   <div className="d-flex">
  //                     <div className="flex-grow-1 ms-4 note py-2 rounded ps-3 pr-10">
  //                       <div className="d-flex justify-content-start align-items-center">
  //                         <div>
  //                           <h6 className="d-inline me-2">Ticket Created By Janvi and assigned to Mohit</h6>{" "}
  //                           at 01-01-2023 12:00:00
  //                         </div>

  //                         <div className="ml-30">
  //                           <a
  //                             className="btn btn-sm activity-log-btn text-info"
  //                             onClick={() => setTicketLogs(true)}
  //                           >
  //                             <i className="fas fa-eye"></i> View
  //                           </a>
  //                         </div>
  //                         {/* <div className="me-4">
  //                           <a
  //                             className="btn btn-sm edit-delete-btn text-success me-2"
  //                             onClick={() => setEditReplyMsg(true)}
  //                           >
  //                             <i className="fas fa-edit" title="Edit Reply"></i>
  //                           </a>
  //                           <button
  //                             className="btn btn-sm edit-delete-btn text-danger"
  //                             onClick={onDeleteReply}
  //                           >
  //                             <i
  //                               className="fas fa-trash-alt"
  //                               title="Delete Reply"
  //                             ></i>
  //                           </button>
  //                         </div> */}
  //                       </div>
  //                       <i className="bi bi-triangle-fill note-icon"></i>
  //                       <div className="Features col-12 my-3">
  //                         Create View Projects Task Section popups, Days
  //                         Remaining popup, Delete popup, View Task popup, and
  //                         changes in Edit and add Project design.
  //                       </div>
  //                       <p className="mb-1">
  //                         Attachment:
  //                         {/* <a
  //                           className="btn btn-sm edit-delete-btn text-secondary ml-10"
  //                           href="path/to/file1"
  //                           target="_blank"
  //                           rel="noreferrer"
  //                         >
  //                           <i className="fas fa-eye"></i> View
  //                         </a> */}
  //                         <a
  //                           className="text-light badge bg-primary ms-2"
  //                           title="Click To Open"
  //                           target="_blank"
  //                           rel="noreferrer"
  //                           href={SampleImg}
  //                           style={{ cursor: "pointer", fontSize: "0.8rem" }}
  //                         >
  //                           Click here
  //                         </a>
  //                         <a
  //                           className="text-light badge bg-primary ms-2"
  //                           title="Click To Open"
  //                           target="_blank"
  //                           rel="noreferrer"
  //                           href={SampleImg}
  //                           style={{ cursor: "pointer", fontSize: "0.8rem" }}
  //                         >
  //                           Click here
  //                         </a>
  //                       </p>
  //                     </div>
  //                   </div>
  //                 </li>

  //                 {/* Message 2 */}
  //                 <li className="event-list position-relative">
  //                   <div className="event-timeline-dot connected-dot">
  //                     <img
  //                       src={userImg}
  //                       className="msgUserImg me-3"
  //                       alt="User Avatar"
  //                     />
  //                   </div>
  //                   <div className="d-flex">
  //                     <div className="flex-grow-1 ms-4 note py-2 rounded ps-3 pr-10">
  //                       <div className="d-flex justify-content-start align-items-center">
  //                         <div>
  //                           <h6 className="d-inline me-2">Mohit Replied to Ticket</h6>{" "}
  //                          at 02-01-2023 15:30:00
  //                         </div>

  //                         <div className="ml-30">
  //                           <a
  //                             className="btn btn-sm activity-log-btn text-info"
  //                             onClick={() => setTicketLogs(true)}
  //                           >
  //                             <i className="fas fa-eye"></i> View
  //                           </a>
  //                         </div>
  //                         {/* <div className="me-4">
  //                           <a
  //                             className="btn btn-sm edit-delete-btn text-success me-2"
  //                             onClick={() => setEditReplyMsg(true)}
  //                           >
  //                             <i className="fas fa-edit" title="Edit Reply"></i>
  //                           </a>
  //                           <button
  //                             className="btn btn-sm edit-delete-btn text-danger"
  //                             onClick={onDeleteReply}
  //                           >
  //                             <i
  //                               className="fas fa-trash-alt"
  //                               title="Delete Reply"
  //                             ></i>
  //                           </button>
  //                         </div> */}
  //                       </div>
  //                       <i className="bi bi-triangle-fill note-icon"></i>
  //                       <div className="Features col-12 my-3">
  //                         Updated the project dashboard UI and fixed issues with
  //                         the user management module.
  //                       </div>
  //                       <p className="mb-1">
  //                         Attachment:
  //                         {/* <a
  //                           className="btn btn-sm edit-delete-btn text-secondary ml-10"
  //                           href="path/to/file2"
  //                           target="_blank"
  //                           rel="noreferrer"
  //                         >
  //                           <i className="fas fa-eye"></i> View
  //                         </a> */}
  //                         <a
  //                           className="text-light badge bg-primary ms-2"
  //                           title="Click To Open"
  //                           target="_blank"
  //                           rel="noreferrer"
  //                           href={SampleImg}
  //                           style={{ cursor: "pointer", fontSize: "0.8rem" }}
  //                         >
  //                           Click here
  //                         </a>
  //                         <a
  //                           className="text-light badge bg-primary ms-2"
  //                           title="Click To Open"
  //                           target="_blank"
  //                           rel="noreferrer"
  //                           href={SampleImg}
  //                           style={{ cursor: "pointer", fontSize: "0.8rem" }}
  //                         >
  //                           Click here
  //                         </a>
  //                       </p>
  //                     </div>
  //                   </div>
  //                 </li>

  //                 {/* Message 3 */}
  //                 <li className="event-list position-relative">
  //                   <div className="event-timeline-dot connected-dot">
  //                     <img
  //                       src={userImg}
  //                       className="msgUserImg me-3"
  //                       alt="User Avatar"
  //                     />
  //                   </div>
  //                   <div className="d-flex">
  //                     <div className="flex-grow-1 ms-4 note py-2 rounded ps-3 pr-10">
  //                       <div className="d-flex justify-content-start align-items-center">
  //                         <div>
  //                           <h6 className="d-inline me-2">Janvi Repplied to Mohit</h6>{" "}
  //                           at 03-01-2023 10:45:00
  //                         </div>

  //                         <div className="ml-30">
  //                           <a
  //                             className="btn btn-sm activity-log-btn text-info"
  //                             onClick={() => setTicketLogs(true)}
  //                           >
  //                             <i className="fas fa-eye"></i> View
  //                           </a>
  //                         </div>
  //                         {/* <div className="me-4">
  //                           <a
  //                             className="btn btn-sm edit-delete-btn text-success me-2"
  //                             onClick={() => setEditReplyMsg(true)}
  //                           >
  //                             <i className="fas fa-edit" title="Edit Reply"></i>
  //                           </a>
  //                           <button
  //                             className="btn btn-sm edit-delete-btn text-danger"
  //                             onClick={onDeleteReply}
  //                           >
  //                             <i
  //                               className="fas fa-trash-alt"
  //                               title="Delete Reply"
  //                             ></i>
  //                           </button>
  //                         </div> */}
  //                       </div>
  //                       <i className="bi bi-triangle-fill note-icon"></i>
  //                       <div className="Features col-12 my-3">
  //                         Implemented API integrations for task management and
  //                         optimized the backend performance.
  //                       </div>
  //                       <p className="mb-1">
  //                         Attachment:
  //                         {/* <a
  //                           className="btn btn-sm edit-delete-btn text-secondary ml-10"
  //                           href="path/to/file3"
  //                           target="_blank"
  //                           rel="noreferrer"
  //                         >
  //                           <i className="fas fa-eye"></i> View
  //                         </a> */}
  //                         <a
  //                           className="text-light badge bg-primary ms-2"
  //                           title="Click To Open"
  //                           target="_blank"
  //                           rel="noreferrer"
  //                           href={SampleImg}
  //                           style={{ cursor: "pointer", fontSize: "0.8rem" }}
  //                         >
  //                           Click here
  //                         </a>
  //                         <a
  //                           className="text-light badge bg-primary ms-2"
  //                           title="Click To Open"
  //                           target="_blank"
  //                           rel="noreferrer"
  //                           href={SampleImg}
  //                           style={{ cursor: "pointer", fontSize: "0.8rem" }}
  //                         >
  //                           Click here
  //                         </a>
  //                       </p>
  //                     </div>
  //                   </div>
  //                 </li>

  //                 {/* Message 4 */}
  //                 <li className="event-list position-relative">
  //                   <div className="event-timeline-dot connected-dot">
  //                     <img
  //                       src={userImg}
  //                       className="msgUserImg me-3"
  //                       alt="User Avatar"
  //                     />
  //                   </div>
  //                   <div className="d-flex">
  //                     <div className="flex-grow-1 ms-4 note py-2 rounded ps-3 pr-10">
  //                       <div className="d-flex justify-content-start align-items-center">
  //                         <div>
  //                           <h6 className="d-inline me-2">Mohit Replied To Janvi</h6>{" "}
  //                           at 03-01-2023 10:45:00
  //                         </div>
  //                         {/* <div className="me-4">
  //                           <a
  //                             className="btn btn-sm edit-delete-btn text-success me-2"
  //                             onClick={() => setEditReplyMsg(true)}
  //                           >
  //                             <i className="fas fa-edit" title="Edit Reply"></i>
  //                           </a>
  //                           <button
  //                             className="btn btn-sm edit-delete-btn text-danger"
  //                             onClick={onDeleteReply}
  //                           >
  //                             <i
  //                               className="fas fa-trash-alt"
  //                               title="Delete Reply"
  //                             ></i>
  //                           </button>
  //                         </div> */}
  //                         <div className="ml-30">
  //                           <a
  //                             className="btn btn-sm activity-log-btn text-info"
  //                             onClick={() => setTicketLogs(true)}
  //                           >
  //                             <i className="fas fa-eye"></i> View
  //                           </a>
  //                         </div>

  //                       </div>
  //                       <i className="bi bi-triangle-fill note-icon"></i>
  //                       <div className="Features col-12 my-3">
  //                         Implemented API integrations for task management and
  //                         optimized the backend performance.
  //                       </div>
  //                       <p className="mb-1">
  //                         Attachment:
  //                         {/* <a
  //                           className="btn btn-sm edit-delete-btn text-secondary ml-10"
  //                           href="path/to/file3"
  //                           target="_blank"
  //                           rel="noreferrer"
  //                         >
  //                           <i className="fas fa-eye"></i> View
  //                         </a> */}
  //                         <a
  //                           className="text-light badge bg-primary ms-2"
  //                           title="Click To Open"
  //                           target="_blank"
  //                           rel="noreferrer"
  //                           href={SampleImg}
  //                           style={{ cursor: "pointer", fontSize: "0.8rem" }}
  //                         >
  //                           Click here
  //                         </a>
  //                         <a
  //                           className="text-light badge bg-primary ms-2"
  //                           title="Click To Open"
  //                           target="_blank"
  //                           rel="noreferrer"
  //                           href={SampleImg}
  //                           style={{ cursor: "pointer", fontSize: "0.8rem" }}
  //                         >
  //                           Click here
  //                         </a>
  //                       </p>
  //                     </div>
  //                   </div>
  //                 </li>
  //               </ul>
  //             </div>
  //           </div>
  //         </ResizableBox>
  //       </Draggable>
  //     </div>

  //     {/* Ticket Logs */}
  //     <div className={`note-sticky-form ${ticketLogs ? "d-block" : "d-none"}`}>
  //       <Draggable>
  //         <ResizableBox
  //           width={900}
  //           style={{
  //             position: "fixed",
  //             top: "25%",
  //             right: "21%",
  //             zIndex: "1055",
  //             backgroundColor: "#fff",
  //           }}
  //         >
  //           <div
  //             className="modal-content"
  //             role="document"
  //           >
  //         <div className="support-logsmodal-header">
  //           <h5 className="modal-title mt-0">Log Details</h5>
  //           <button
  //             type="button"
  //             onClick={() => {
  //               setTicketLogs(false)
  //             }}
  //             className="btn-modal-close"
  //           >
  //             <span aria-hidden="true" className="btn-modal-span">
  //               &times;;
  //             </span>
  //           </button>
  //         </div>
  //       <div className="support-logsmodal-body">
  //         <div className="table-responsive">
  //           <table className="table mb-0 table">
  //             <thead className="table-light">
  //               <tr>
  //                 <th>Fields</th>
  //                 <th>Old Data</th>
  //                 <th>New Data</th>
  //               </tr>
  //             </thead>
  //             <tbody>
  //                   <tr >
  //                     <th scope="row">Assign</th>
  //                     <td>
  //                       <div>
  //                         Rahul
  //                       </div>
  //                     </td>
  //                     <td>
  //                       <div>
  //                         Mohit
  //                       </div>
  //                     </td>
  //                   </tr>
  //             </tbody>
  //           </table>
  //         </div>
  //       </div>
  //           </div>
  //         </ResizableBox>
  //       </Draggable>
  //     </div>

  //     {/* <Modal size="md" centered isOpen={viewData} className="activity-log">
  //       <div className="modal-header">
  //         <h5 className="modal-title mt-0">Log Details</h5>
  //         <button
  //           type="button"
  //           onClick={() => {
  //             setViewData(false)
  //           }}
  //           className="btn-modal-close"
  //         >
  //           <span aria-hidden="true" className="btn-modal-span">
  //             &times;;
  //           </span>
  //         </button>
  //       </div>
  //       <div className="modal-body">
  //         <div className="table-responsive">
  //           <table className="table mb-0 table">
  //             <thead className="table-light">
  //               <tr>
  //                 <th>Fields</th>
  //                 <th>Old Data</th>
  //                 <th>New Data</th>
  //               </tr>
  //             </thead>
  //             <tbody>
  //                   <tr >
  //                     <th scope="row">assignee</th>
  //                     <td>
  //                       <div>
  //                         Rahul
  //                       </div>
  //                     </td>
  //                     <td>
  //                       <div>
  //                         Mohit
  //                       </div>
  //                     </td>
  //                   </tr>
  //             </tbody>
  //           </table>
  //         </div>
  //       </div>
  //     </Modal> */}

  //   </React.Fragment>
  // )

  return (
    <React.Fragment>
      <div className="page-content d-flex align-items-center justify-content-center" style={{height :"100vh" , width:"100%"}}>
        <Container fluid>
          <h1 className="fw-bold text-center">Coming Soon</h1>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default HostingIndex;
